import { PIXKeyTypes } from '../utils/payments';
import { MenuItemFavorited } from './menu-item';

type DaysText = 'domingo' | 'segunda' | 'terca' | 'quarta' | 'quinta' | 'sexta' | 'sabado';

type DaysWeekTax = {
  [key in DaysText]: number;
};

type Gift = {
  name: string;
  menusIds: string[];
  daysOfWeek: number[];
};

export type RestaurantCustomConfig = {
  apenasEncomenda: boolean;
  entregaEmOutrasCidades: boolean;
  valorDeCompraComTaxaEntrega: number;
  mostrarValorTotalDoPedido: boolean;
  liberarPagamentoPorPix: boolean;
  chavePIX: string;
  tipoDaChavePIX: PIXKeyTypes | null;
  cardapioApenasParaVisualizacao?: boolean;
  desativarPedidosNaMesaEBalcao?: boolean;
  placeholderCustomizado?: string;
  youtubeVideoId?: string;
  taxaEntregaPorDiasDaSemana?: DaysWeekTax;
  usarTaxaEntregaPorDiasDaSemana?: boolean;
  brinde?: Gift;
};

export type Restaurant = {
  cliqueiAcheiId: number;
  whatsapp: string;
  aceitaRetiradaNoLocal: boolean;
  taxaEntrega: number;
  pedidoMinimo: number;
  tempoPrevistoParaEntregaMinimo: number;
  tempoPrevistoParaEntregaMaximo: number;
  ativo: boolean;
  Configuracoes: null | RestaurantCustomConfig;
  menus: Menu[];
  horariosDeEntrega: any[];
  horarioDeEntregaHoje: null;
  entregandoAgora: true;
  id: string;
  dataCadastro: string;
  requestDate: string;
  estaDeFerias: boolean;
};

export enum MenuTypes {
  Default = 0,
  Pizza = 1,
  Favorite = 99,
}

export type Menu = {
  nome: string;
  disponivelParaEntrega: boolean;
  disponivelParaConsumoNoLocal: boolean;
  sempreDisponivel: boolean;
  ativo: boolean;
  ordem: number;
  tipoMenu: MenuTypes;
  restauranteId: string;
  itens: (MenuItem | MenuItemFavorited)[];
  disponibilidade: any[];
  disponivel: boolean;
  id: string;
  dataCadastro: string;
  requestDate: string;
};

export type MenuItem = {
  categoriaId: string;
  gruposDeComplementos: ComplementGroup[];
  precoApartirDe: number | null;
  nome: string;
  descricao: string;
  codigoPdv: string;
  foto: string | null;
  preco: number;
  precoPromocional: number;
  ativo: boolean;
  ordem: number;
  exclusivoParaRetirada: boolean;
  proibeObservacoes: boolean;
  id: string;
  dataCadastro: string;
  requestDate: string;
};

export type ComplementGroup = {
  nome: string;
  ativo: boolean;
  ordem: number;
  opcional: boolean;
  precificaPeloMaisCaro: boolean;
  minimo: number;
  maximo: number;
  itemId: string;
  complementos: Complement[];
  id: string;
  dataCadastro: string;
  requestDate: string;
};

export type Complement = {
  grupoId: string;
  nome: string;
  descricao: string;
  codigoPdv: string;
  foto: string | null;
  preco: number;
  precoPromocional: number;
  ativo: boolean;
  ordem: number;
  exclusivoParaRetirada: boolean;
  proibeObservacoes: boolean;
  id: string;
  dataCadastro: string;
  requestDate: string;
  amount?: number;
};

export type Schedule = {
  Dia: number;
  Fechado: boolean;
  VinteQuatroHoras: boolean;
  HorarioAlmoco: boolean;
  Abre: string;
  FechaAlmoco: string | null;
  VoltaAlmoco: string | null;
  Fecha: string;
  DiaDaSemana: string;
  DiaDaSemanaEn: string;
};

export type CliqueiAcheiData = {
  Cod_Cliente: number;
  ModeloPaginaId: number;
  Nome: string;
  Atividade: string;
  CorMenu: string | null;
  CorMenuText: string | null;
  Url_Cliente: string;
  Aberto: boolean;
  Entrega: boolean;
  Nom_Categoria: string;
  Cod_Categoria: number;
  Completo: boolean;
  FormasPagamento: string[];
  Url_BannerPagina: string | null;
  Url_Cidade: string;
  NomePuro: string;
  Horarios: Schedule[];
  Email: string[];
  UsaAgenda: boolean;
};

export type User = {
  name: string;
  cellphone: string;
};

export type Address = {
  id: string;
  cep?: string;
  // name: string;
  landmark?: string;
  street: string;
  number?: string;
  complement: string;
  neighborhood: string;
  city: City;
};

export type City = {
  Cod_Cidade: number;
  Nom_Cidade: string;
  Url_Cidade: string;
  Sigla_UF: string;
};

export type StoryPreview = {
  ClienteId: number;
  ModeloPaginaId: number;
  Url: string;
  Nome: string;
  Logo: string | null;
  CorMenu: string | null;
  CorMenuText: string | null;
  Aberto: boolean;
  Entrega: boolean;
  ContemPromocao: boolean;
  PrimeiraPostagem: string;
  TotalStories: number;
  TotalPendentes: number;
  Pendente: boolean;
  ViewMap: boolean[];
  ProximoStorie: Story | null;
};

export type Story = {
  FotoId: number;
  Foto: string;
  Legenda: string;
  Promocao: boolean;
  Like: boolean;
  TotalLikes: number;
  TotalViews: number;
  PostadaEm: string;
  VisualizadoEm: string | null;
  UserPhoto: string | null;
  UserName: string | null;
  UserDeviceId: string | null;
};

export type ClientBusiness = {
  ClienteId: number;
  PrimeiroNome: string;
  Sobrenome: string;
  NomeCompleto: string;
  NomeFantasia: string;
  Endereco: string;
  Numero: number;
  Bairro: string;
  CEP: number;
  Email: string;
  MostraEmail: string;
  Site: string;
  Facebook: string;
  Instagram: string;
  Descricao: string;
  Senha: string;
  CidadeId: number;
  DataCadastro: string;
  SenhaTemp: string;
  CategoriaId: number;
  Logo: string;
  LogoCliente: {
    ClienteId: number;
    NomeArquivo: string;
    Legenda: string;
  };
  Slug: string;
  Status: string;
  EmailValidado: string;
  ObservacoesAtendimento: string;
  DataUltimoAcesso: string;
  NumeroAcessos: number;
  ClienteDesde: string;
  AnuncioBasico: string;
  SlugPersonalizada: string;
  SenhaTemporaria: string;
  AceitouTermosUso: string;
  OcultarEndereco: string;
  SlugPersonalizadaLiberada: boolean;
  AtividadePrincipal: string;
  NovoCadastro: boolean;
  ContadorUrlPersonalizada: number;
  UrlVideoEmbedded: string;
  BitTemTour: boolean;
  CodigoFichaGoogle: string;
  GooglePlaceId: string;
  CodigoPainelFichaGoogle: string;
  WhatsAppEmpresario: string;
  EmailEmpresario: string;
  NomeEmpresario: string;
  ModeloPaginaId: PageModels;
  BitTesteGratis: false;
};

export enum PageModels {
  ListaZap = 1,
  Pedidos = 2,
  PedidosWhatsapp = 3,
  CardapioBarriga = 5,
}

export enum DeliveryTypesAvailable {
  LocalPickup = 'Retirada no Local',
  HomeDelivery = 'Entregar no Endereço',
}
